<div class="info-tag" (click)="openDrawer()">
  <img src="/assets/svg/info-tag.svg" alt="" />
</div>
